import { notificationsListingStore } from '@/app/features/notifications/features/notifications-listing/notifications-listing.store';

export const notificationsStore = {
  modules: {
    notificationsListingState: notificationsListingStore
  }
};
